module.exports = __webpack_public_path__ + "img/186109615426787.59297ddd.jpg";